import React, { useEffect, useState } from 'react';
import './App.css';
import { asCounts, randomHandPlus, toReadable } from "./hand"
import img, { concat, copiesFromSVGCode, loadTileImages, svgTileBackground } from "./img"
import { distance } from './hand/distance'


function App() {
  const rh = randomHandPlus()
  const hand = rh.map(tile => img.fluffystuff(tile))
  const [concatenated, setConcatenated] = useState<string>()
  useEffect(() =>
  {
    (async () =>
    {
      const tileImages = await loadTileImages(hand)
      const backgroundImages = await copiesFromSVGCode(svgTileBackground({
        width: tileImages[0].width as number,
        height: tileImages[0].height as number,
      }), tileImages.length)
      setConcatenated(concat(tileImages, backgroundImages, {paddingLR: 20}))
    })()
  }, [hand])
  const readable = toReadable(rh)

  return (<>
    <div className="App">
      <h1>今日の手牌</h1>
      <p>{distance(asCounts(rh))-1}向聴</p>
      <p>
      <a className="twitter-share-button" href={`https://twitter.com/intent/tweet?text=${encodeURIComponent("#今日の手牌 ")+encodeURIComponent(readable+"\n")+encodeURIComponent(window.location.href)}`}>Tweet</a>
      <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
      </p>
      {
        (concatenated !== undefined)?
        <img src={concatenated} alt={readable} className="merged" />
        :<></>
      }
    </div>
    <div>
      <h2 style={{textAlign: 'center'}}>Description</h2>
      <ul>
        <li>Seed a Mersenne Twister with [Year, Month, Day]</li>
        <li>Generate a random hand</li>
        <li>Merge <a href="https://github.com/FluffyStuff/riichi-mahjong-tiles">images</a></li>
      </ul>
    </div>
  </>)
}

export default App;
